if (!customElements.get('infinite-collection')) {
  class InfiniteCollection extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('#product-grid');
      this.button = this.querySelector('[data-infinite-load-button]');
      this.oldNav = this.querySelector('.pagination-wrapper');
      this.loading = false;

      if (!this.button || !this.grid) return;

      // JS calisiyor: eski numarali sayfalama gizlenir. Buton her zaman
      // gorsel olarak gizli (visually-hidden) - sadece kaydirma tetikleyicisi
      // ve JS calismazsa gercek bir <a href> fallback'i olarak duruyor.
      if (this.oldNav) this.oldNav.style.display = 'none';

      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && !this.loading) {
            this.loadNext();
          }
        },
        { rootMargin: '600px' }
      );
      this.observer.observe(this.button);

      this.button.addEventListener('click', (event) => {
        event.preventDefault();
        this.loadNext();
      });
    }

    loadNext() {
      const nextUrl = this.button.dataset.nextUrl;
      if (!nextUrl || this.loading) return;
      this.loading = true;

      const sectionId = this.dataset.sectionId;
      const separator = nextUrl.includes('?') ? '&' : '?';
      const fetchUrl = `${nextUrl}${separator}section_id=${sectionId}`;

      fetch(fetchUrl)
        .then((response) => response.text())
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const newItems = doc.querySelectorAll('#product-grid > li');
          newItems.forEach((item) => this.grid.appendChild(item));

          const newButton = doc.querySelector('[data-infinite-load-button]');
          if (newButton && newButton.dataset.nextUrl) {
            this.button.dataset.nextUrl = newButton.dataset.nextUrl;
          } else {
            this.observer.disconnect();
            this.button.remove();
          }
        })
        .catch(() => {
          // Ag hatasi olursa buton gercek bir <a href> oldugu icin tiklamaya devam eder,
          // tarayici normal sayfa gecisi yapar (fallback).
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }

  customElements.define('infinite-collection', InfiniteCollection);
}
